import { render, staticRenderFns } from "./AgencySummaryTable.vue?vue&type=template&id=58e72278&"
import script from "./AgencySummaryTable.vue?vue&type=script&lang=ts&"
export * from "./AgencySummaryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QIcon,QTd} from 'quasar'
component.options.components = Object.assign({QTable,QTr,QTh,QIcon,QTd}, component.options.components || {})
